import { FMS, type Version } from '@storebrand-digital/fms-translations';
import { normalizeLanguage } from '@bank/utils';
import { FormatText, type Tags } from '@bank/components';
import type { FmsKeys } from './FmsTypes';
import { isProdEnv } from '@/utils/env';
const {
  init,
  getText,
  getJSON,
  getCurrentLanguage: getFmsLanguage,
} = new FMS<FmsKeys>({
  clientId: window.env.CLIENT_ID,
  documentIds: ['bankOnboarding'],
  customerApiUrl: isProdEnv
    ? 'https://api.storebrand.no'
    : 'https://api-t.storebrand.no',
  version: window.env.TRANSLATION_VERSION as Version,
  getFallbackTextsForLanguage: async (language) =>
    language === 'en'
      ? (await import('./fallback-en.json')).default
      : (await import('./fallback-no.json')).default,
});

const getCurrentLanguage = () => normalizeLanguage(getFmsLanguage());

type TextOptions = Parameters<typeof getText>[1];

interface FormatTextFMSProps<Key extends FmsKeys> {
  fmsKey: Key;
  options?: TextOptions;
  tags?: Tags;
}

const FormatTextFMS = <Key extends FmsKeys>({
  fmsKey,
  options,
  tags = {},
}: FormatTextFMSProps<Key>) => (
  <FormatText text={getText(fmsKey, options)} tags={tags} />
);

export {
  init,
  getText,
  getJSON,
  getCurrentLanguage,
  FormatTextFMS,
  type FormatTextFMSProps,
};
